const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/reports.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/reports")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});